/**
 * Recursively traverses route definitions and returns names of routes that have the specified property.
 * If returnRouteObjects is true, returns the matching route objects (without children) instead.
 * @param {Array} routes - Array of Vue route objects
 * @param {string} property - Property to check for in each route
 * @param {boolean} returnRouteObjects - Whether to return route objects instead of names
 * @returns {Array} Array of route names or route objects that have the specified property
 */
const getRoutesWithProperty = (routes, property, returnRouteObjects = false) => {
  const routesWithProperty = [];
  routes.forEach(route => {
    if (route.name && route[property]) {
      if (returnRouteObjects) {
        const routeWithoutChildren = { ...route };
        delete routeWithoutChildren.children;
        routesWithProperty.push(routeWithoutChildren);
      } else {
        routesWithProperty.push(route.name);
      }
    }
    if (route.children) {
      routesWithProperty.push(
        ...getRoutesWithProperty(route.children, property, returnRouteObjects),
      );
    }
  });
  return routesWithProperty;
};

export default getRoutesWithProperty;
